import { Route, Routes } from "react-router-dom";
import TecCreacionOnline from "../newPages/tecnologias/TecCreacionOnline";
import TecCreacionPresencial from "../newPages/tecnologias/TecCreacionPresencial";
import TecContabilidad from "../newPages/tecnologias/TecContabilidad";
import TecMarketing from "../newPages/tecnologias/TecMarketing";
import TecModeladoBim from "../newPages/tecnologias/TecModeladoBim";
import TecNegociacion from "../newPages/tecnologias/TecNegociacion";
import TecComunicacionEstrategica from "../newPages/tecnologias/TecComunicacionEstrategica";

function RoutesTec() {
  return (
    <>
      <Routes>
        {" "}
        <Route
          path="/tecnologia-audiovisual-online"
          element={<TecCreacionOnline></TecCreacionOnline>}
        />

         <Route
          path="/tecnologia-audiovisual"
          element={<TecCreacionPresencial></TecCreacionPresencial>}
        />
          <Route
          path="/tecnologia-contabilidad"
          element={<TecContabilidad></TecContabilidad>}
        />

          <Route
          path="/tecnologia-marketing-turistico"
          element={<TecMarketing></TecMarketing>}
        />

          <Route
          path="/tecnologia-modelado-bim"
          element={<TecModeladoBim></TecModeladoBim>}
        />

             <Route
          path="/tecnologia-negociacion-ventas"
          element={<TecNegociacion></TecNegociacion>}
        />
            <Route
          path="/tecnologia-comunicacion"
          element={<TecComunicacionEstrategica></TecComunicacionEstrategica>}
        />
       
      </Routes>{" "}
    </>
  );
}

export default RoutesTec;
